// @ts-nocheck
import Vue from "vue";
/*
 * path: 请求路径
 * name: 删除（文件）名称
 * next: 删除成功后执行的方法
 * ajaxType: 请求方式，，不传默认delete，可选参数
 * data: 请求参数，可选参数
 */
export function Delete(path, name, next, nowWillDo, ajaxType, data) {
  let button = document.querySelector("button");
  Vue.prototype
    .$confirm(`此操作将删除 ${name}, 是否继续?`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
    .then(() => {
      nowWillDo && nowWillDo(true);
      // 选一个button触发focus，防止删除组件默认触发的focus，导致删除提示自己显示
      button.focus();
      Vue.prototype.$http[ajaxType || "delete"](path, data)
        .then(() => {
          Vue.prototype.$notify({
            title: "成功",
            message: `${name} 删除成功!`,
            type: "success",
            duration: 2000
          });
          next();
        })
        .finally(() => {
          nowWillDo && nowWillDo(false);
        });
    })
    .catch(() => {
      button.focus();
      Vue.prototype.$notify.info({
        title: "消息",
        message: "已取消删除",
        duration: 2000
      });
    });
}

/*
 * path: 请求路径
 * name: 删除（文件）名称
 * next: 删除成功后执行的方法
 * ajaxType: 请求方式，，不传默认delete，可选参数
 * data: 请求参数，可选参数
 */
export function DeletePrompt(path, name, next, nowWillDo, ajaxType, data) {
  let button = document.querySelector("button");
  Vue.prototype
    .$prompt(
      `<div style="display:flex;align-items:center;flex-wrap: wrap;"><div class='el-icon-warning' style="font-size: 24px;color:#e6a23c;margin-right: 5px;"></div>此操作将删除 <span style="color:red;"><strong> ${name} </strong></span> 文件夹, 请输入该文件夹名称以继续?</div>`,
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: new RegExp(name),
        inputErrorMessage: "输入的文件夹名称与要删除的文件夹名称不一致",
        dangerouslyUseHTMLString: true
        // type: "warning",
        // center: true
      }
    )
    .then(({ value }) => {
      nowWillDo && nowWillDo(true);
      // 选一个button触发focus，防止删除组件默认触发的focus，导致删除提示自己显示
      button.focus();
      console.log(value);

      Vue.prototype.$http[ajaxType || "delete"](`${path}${value}`, data)
        .then(() => {
          Vue.prototype.$notify({
            title: "成功",
            message: `${name} 删除成功!`,
            type: "success",
            duration: 2000
          });
          next();
        })
        .finally(() => {
          nowWillDo && nowWillDo(false);
        });
    })
    .catch(() => {
      button.focus();
      Vue.prototype.$notify.info({
        title: "消息",
        message: "已取消删除",
        duration: 2000
      });
    });
}
/*
 * pathArr: 请求路径数组
 * nameArr: 删除（文件）名称数组
 * next: 删除成功后执行的方法
 * ajaxType: 请求方式，，不传默认delete，可选参数
 * data: 请求参数，可选参数
 */
export function DeleteArr(pathArr, nameArr, next, nowWillDo, ajaxType, data) {
  let button = document.querySelector("button");
  let name = nameArr.join(",");
  Vue.prototype
    .$confirm(`此操作将删除 ${name}, 是否继续?`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
    .then(() => {
      nowWillDo && nowWillDo(true);
      // 选一个button触发focus，防止删除组件默认触发的focus，导致删除提示自己显示
      button.focus();
      let request = pathArr.map(p =>
        Vue.prototype.$http[ajaxType || "delete"](p, data)
      );
      Promise.all(request)
        .then(res => {
          res.forEach((r, i) => {
            setTimeout(() => {
              Vue.prototype.$notify({
                title: "成功",
                message: `${nameArr[i]} 删除成功!`,
                type: "success",
                duration: 2000
              });
            }, 200);
          });
          next();
        })
        .finally(() => {
          nowWillDo && nowWillDo(false);
        });
    })
    .catch(() => {
      button.focus();
      Vue.prototype.$notify.info({
        title: "消息",
        message: "已取消删除",
        duration: 2000
      });
    });
}
/*
 * path: 请求路径
 * name: 下载文件名
 */
export function Download(path, name, index = 0) {
  setTimeout(() => {
    if (typeof path === "object" && window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(path, name);
    } else {
      let alink = document.createElement("a");
      alink.download = name;
      alink.href = path;
      document.body.appendChild(alink);
      alink.click();
      setTimeout(() => {
        document.body.removeChild(alink);
      }, 20);
    }
  }, 50 * index);
}
